import 'js/app/setupEnvironment';

import appEnv from 'bundles/groups/appEnv';
import appStarterFactory from 'bundles/page/lib/appStarterFactory';

export default appStarterFactory(appEnv);
